<!-- The 13 share buttons, previously repeated verbatim in 8 templates.
     Labels come through labelFor() so a missing CMS string falls back to the
     platform name rather than leaving the button nameless - the runtime-label
     trap that has bitten this site four times. -->
<ng-container>
<button *ngIf="has('facebook')" class="social-share raksme-tooltip" shareButton="facebook" #fbBtn="shareButton" style="color: #4267B2;" title="{{ labelFor('facebook')}}">
                            <fa-icon *ngIf="fbBtn" [icon]="fbBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('facebook')}}</span>
                        </button>
    
                        <button *ngIf="has('twitter')" class="social-share raksme-tooltip" shareButton="twitter" #twBtn="shareButton" style="color: #000000;" title="X">
                            <raksme-brand-icon name="x" size="lg"></raksme-brand-icon>
                            <span class="tooltiptext">X</span>
                        </button>
    
                        <button *ngIf="has('linkedin')" class="social-share raksme-tooltip" shareButton="linkedin" #lnBtn="shareButton" style="color: #006fa6;" title="{{ labelFor('linkedin')}}">
                            <fa-icon *ngIf="lnBtn" [icon]="lnBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('linkedin')}}</span>
                        </button>
    
                        <button *ngIf="has('whatsapp')" class="social-share raksme-tooltip" shareButton="whatsapp" #wpBtn="shareButton" style="color: #25D366;" title="{{ labelFor('whatsapp')}}">
                            <fa-icon *ngIf="wpBtn" [icon]="wpBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('whatsapp')}}</span>
                        </button>
    
                        <button *ngIf="has('pinterest')" class="social-share raksme-tooltip" shareButton="pinterest" #pntBtn="shareButton" style="color: #BD091D;" title="{{ labelFor('pinterest')}}">
                            <fa-icon *ngIf="pntBtn" [icon]="pntBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('pinterest')}}</span>
                        </button>
    
                        <button *ngIf="has('reddit')" class="social-share raksme-tooltip" shareButton="reddit" #redBtn="shareButton" style="color: #FF4006;" title="{{ labelFor('reddit')}}">
                            <fa-icon *ngIf="redBtn" [icon]="redBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('reddit')}}</span>
                        </button>
    
    
                        <button *ngIf="has('tumblr')" class="social-share raksme-tooltip" shareButton="tumblr" #tmbBtn="shareButton" style="color: #36465D;" title="{{ labelFor('tumblr')}}">
                            <fa-icon *ngIf="tmbBtn" [icon]="tmbBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('tumblr')}}</span>
                        </button>
    
                        <button *ngIf="has('telegram')" class="social-share raksme-tooltip" shareButton="telegram" #tlgBtn="shareButton" style="color: #0088cc;" title="{{ labelFor('telegram')}}">
                            <fa-icon *ngIf="tlgBtn" [icon]="tlgBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('telegram')}}</span>
                        </button>
    
                        <button *ngIf="has('messenger')" class="social-share raksme-tooltip" shareButton="messenger" #msgBtn="shareButton" style="color: #0080FF;" title="{{ labelFor('messenger')}}">
                            <fa-icon *ngIf="msgBtn" [icon]="msgBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('messenger')}}</span>
                        </button>
    
                        <button *ngIf="has('xing')" class="social-share raksme-tooltip" shareButton="xing" #xgBtn="shareButton" style="color: #006567;" title="{{ labelFor('xing')}}">
                            <fa-icon *ngIf="xgBtn" [icon]="xgBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('xing')}}</span>
                        </button>
    
                        <button *ngIf="has('sms')" class="social-share raksme-tooltip" shareButton="sms" #smsBtn="shareButton" style="color: #20c16c;" title="{{ labelFor('sms')}}">
                            <fa-icon *ngIf="smsBtn" [icon]="smsBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('sms')}}</span>
                        </button>
    
                        <button *ngIf="has('email')" class="social-share raksme-tooltip" shareButton="email" #emailBtn="shareButton" style="color: #FF961C;" title="{{ labelFor('email')}}">
                            <fa-icon *ngIf="emailBtn" [icon]="emailBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('email')}}</span>
                        </button>
    
                        <button *ngIf="has('print')" class="social-share raksme-tooltip" shareButton="print" #prtBtn="shareButton" style="color: #765AA2;" title="{{ labelFor('print')}}">
                            <fa-icon *ngIf="prtBtn" [icon]="prtBtn.icon" size="lg"></fa-icon>
                            <span class="tooltiptext">{{ labelFor('print')}}</span>
                        </button>
</ng-container>
